import { render, staticRenderFns } from "./GlobalSidebarMenu.vue?vue&type=template&id=1f0e2e46&scoped=true"
import script from "./GlobalSidebarMenu.vue?vue&type=script&lang=js"
export * from "./GlobalSidebarMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f0e2e46",
  null
  
)

export default component.exports